import styled from 'styled-components';
import { Label } from 'atoms/Texts';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const StyledLabel = styled(Label)`
  line-height: 14px;
  font-size: 12px;
  margin-bottom: 0px;
  margin-right: 0.5rem;
`